// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"d8fe58cdc7f3261180347c2d9fca426fba1b7595802888d5f60fa8482ce6467b","node_modules_react_index_js":"7d7485f470234010ac1ac35604536f8ddc0956bd2335506d15e1168db6893246"}[chunkId] + ".js";
};